import { render, staticRenderFns } from "./NewCourseNotStarted.vue?vue&type=template&id=7665bf5a"
import script from "./NewCourseNotStarted.vue?vue&type=script&lang=js"
export * from "./NewCourseNotStarted.vue?vue&type=script&lang=js"
import style0 from "./NewCourseNotStarted.vue?vue&type=style&index=0&id=7665bf5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports